import { Model } from '@vuex-orm/core'

export default class Weapon extends Model {
    static entity = 'weapons'

    static fields() {
        return {
            id: this.attr(null),
            icon: this.attr(''),
            name: this.attr(''), 
            baseDamageType: this.attr(''),
            baseDamageMin: this.attr(0),
            baseDamageMax: this.attr(0),
            extraDamageType: this.attr(''),
            extraDamage: this.attr(0),
            speed: this.attr(0),
            criticalChance: this.attr(0),
            criticalMultiplicator: this.attr(0)
        }
    }
}